import React, { useEffect, useState } from 'react';
import { addCommas } from '@persian-tools/persian-tools';
import { useSelector } from 'react-redux';
import Button from '@/components/UI/button/Button';
import useDrawer from '@/hooks/useDrawer';
import { CalendarPricingType } from '@/components/houses/_hooks/useProduct';
import PriceBoxDrawer from '../priceBoxDrawer/PriceBoxDrawer';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import Typography from '@/components/UI/typography/Typography';
import Badges from '@/components/UI/badges/Badges';
import Icon from '@/components/UI/icon/Icon';
import styles from './PriceBoxMobile.module.scss';
import { useMidTermQuery } from '../../_hooks/useMidterm';
import MidtermPriceBox from '../MidtermPriceBox/MidtermPriceBox';
import { ProductItemTypes } from '../../_types/productItem.types';
import { formatPersianDates } from '@/helpers/dateManager';
type IPriceBoxMobile = {
  isNonBookable?: boolean;
  calendarPricing: CalendarPricingType;
  productState: ProductItemTypes;
  onSendReserveRequestClick: any;
  openComments?: any;
  loading?: boolean;
};
const PriceBoxMobile = ({
  isNonBookable,
  calendarPricing,
  productState,
  onSendReserveRequestClick,
  openComments,
  loading
}: IPriceBoxMobile) => {
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const price = productState?.pricing?.price_to_show;
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const {
    isMidTerm
  } = useMidTermQuery(productState);
  const proformaState = useSelector(state => state.proforma);
  const [finalizedPrice, setFinalizedPrice] = useState<any>(null);
  const [formBtnText, setFormBtnText] = useState('');
  const [reserveText, setReserveText] = useState('ارسال درخواست رزرو');
  useEffect(() => {
    setFinalizedPrice(proformaState.data?.total_payable_amount);
  }, [proformaState]);
  useEffect(() => {
    if (!!calendarPricing?.houseCalendarData?.today && !checkout) {
      setFormBtnText('ثبت رزرو');
      setReserveText('ثبت رزرو');
    } else {
      setFormBtnText('ارسال درخواست رزرو');
      setReserveText('ارسال درخواست رزرو');
    }
  }, [checkin, checkout, guests, calendarPricing?.houseCalendarData?.today]);
  const convertDateTime = time => {
    const convertedTime = new Date(time * 1000);
    const comvertedDates = formatPersianDates(convertedTime, {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
    return `${comvertedDates.year}/${comvertedDates.month}/${comvertedDates.day}`;
  };
  return <section data-sentry-component="PriceBoxMobile" data-sentry-source-file="PriceBoxMobile.tsx">
      <PriceBoxDrawer rules={productState?.rules?.records} id={productState?.id} isOpenDrawer={isDrawerOpen('CALENDAR')} calendarPricing={calendarPricing} handleClose={() => drawerClose()} onSendReserveRequestClick={onSendReserveRequestClick} loading={loading as boolean} data-sentry-element="PriceBoxDrawer" data-sentry-source-file="PriceBoxMobile.tsx" />
      <Box className={styles['price-box']} data-sentry-element="Box" data-sentry-source-file="PriceBoxMobile.tsx">
        {!isMidTerm ? <>
            <Box className={styles['price-box-info']}>
              {proformaState.loading ? <Skeleton variant="text" width={80} /> : <Box className={styles['price-box-info-pricing']}>
                  <Typography variant="bodyM" color="neutral_700">
                    {finalizedPrice?.final_price ? 'قیمت کل' : 'هر شب از'}
                  </Typography>
                  <Typography variant="title_Bold">
                    {addCommas(finalizedPrice?.final_price ?? price?.amount)}
                  </Typography>
                  <Typography variant="bodyS" color="neutral_700">
                    {price?.currency_name}
                  </Typography>
                </Box>}
              {isNonBookable ? '' : !!checkin && !!checkout ? <Box className={styles['price-box-info-date']} onClick={() => drawerOpen('CALENDAR')}>
                  <Typography variant="bodyM" color="neutral_main" className={styles['price-box-info-date-text']}>
                    {convertDateTime(checkin)} تا {convertDateTime(checkout)}{' '}
                  </Typography>
                  <Icon name="edit-2" type="mediumEmphasis" />
                </Box> : productState?.reviews_count === 0 ? <Badges label=" جدید" type="primary" size="large" /> : <Box className={styles['price-box-info-review']}>
                  <Icon name="star-filled" type="primary" size={'xSmall'} />
                  {productState?.rates?.rank && <Typography variant="bodyL">
                      {productState?.rates?.rank}
                    </Typography>}
                  <Typography onClick={openComments} variant="bodyM" color="neutral_main" className={styles['price-box-info-date-text']}>
                    ({productState?.reviews_count}) نظر
                  </Typography>
                </Box>}
            </Box>
            <Box className={styles['price-box-action']}>
              {!!checkin && !!checkout ? <>
                  {!isNonBookable && <Typography variant="bodyM" className={styles['price-box-action-badge']}>
                      رایگان
                    </Typography>}
                  <Button format="primary" onClick={() => drawerOpen('CALENDAR')} size="large" disabled={isNonBookable}>
                    {isNonBookable ? 'غیرفعال' : formBtnText}
                  </Button>
                </> : <Button format="primary" onClick={() => drawerOpen('CALENDAR')} disabled={isNonBookable} size="large">
                  {isNonBookable ? 'غیرفعال' : reserveText}
                </Button>}
            </Box>
          </> : <MidtermPriceBox onSendReserveRequestClick={onSendReserveRequestClick} data={productState} loading={loading} />}
      </Box>
    </section>;
};
export default PriceBoxMobile;